<template>
    <section class="mobile-orders-page">
        <van-nav-bar title="我的订单" left-arrow fixed placeholder z-index="100" safe-area-inset-top @click-left="goBack" />

        <main class="mobile-orders-main">
            <section class="mobile-orders-hero">
                <div><span>ORDER ARCHIVE</span><h1>订单记录</h1><p>查看产品订单与处理状态，移动端暂不提供付款操作。</p></div>
                <van-icon name="records-o" />
            </section>

            <van-tabs v-model="orderType" sticky :offset-top="46" color="#d09b35" title-active-color="#7b5519" @change="changeType">
                <van-tab title="PRO 与网络版" name="pro" />
                <van-tab title="手机 APP" name="app" />
            </van-tabs>

            <div class="mobile-orders-toolbar">
                <span>共 {{ total }} 笔订单</span>
                <button type="button" @click="refresh"><van-icon name="replay" /> 刷新</button>
            </div>

            <van-list v-model="loading" :finished="finished" finished-text="没有更多订单了" @load="loadOrders">
                <div v-if="orders.length" class="mobile-orders-list">
                    <article v-for="order in orders" :key="order.order_id" class="mobile-order-card">
                        <header>
                            <div class="mobile-order-card__product-icon"><van-icon :name="orderType === 'pro' ? 'desktop-o' : 'phone-o'" /></div>
                            <div><span>{{ orderType === 'pro' ? 'BIGEMAP PRODUCT' : 'BIGEMAP APP' }}</span><h2>{{ productName(order) }}</h2></div>
                            <van-tag round :type="statusInfo(order).type">{{ statusInfo(order).text }}</van-tag>
                        </header>

                        <div class="mobile-order-card__price">
                            <span>订单金额</span><strong>¥{{ formatPrice(order.pay_price != null ? order.pay_price : order.price) }}</strong>
                        </div>

                        <div class="mobile-order-card__details">
                            <div><span>订单编号</span><strong>{{ order.order_id || '—' }}</strong></div>
                            <div v-if="orderType === 'pro' && order.net_sum"><span>授权节点</span><strong>{{ order.net_sum }} 个</strong></div>
                            <div><span>创建时间</span><strong>{{ formatTime(order.create_time) }}</strong></div>
                            <div v-if="order.pay_time"><span>付款时间</span><strong>{{ formatTime(order.pay_time) }}</strong></div>
                        </div>

                        <footer v-if="orderType === 'pro'">
                            <span><van-icon name="bill-o" /> 发票状态</span>
                            <strong>{{ invoiceText(order.invoice_status) }}</strong>
                        </footer>
                    </article>
                </div>
                <van-empty v-else-if="!loading" image="search" description="暂无订单记录" />
            </van-list>
        </main>
    </section>
</template>

<script>
export default {
    name: 'MobileOrders',
    data() {
        return {
            orderType: 'pro',
            orders: [],
            total: 0,
            loading: false,
            finished: false,
            pageNumber: 0,
            pageSize: 10,
        };
    },
    methods: {
        goBack() { this.$router.push({path: '/user/profile/setting'}); },
        changeType() { this.refresh(); },
        refresh() {
            this.orders = [];
            this.pageNumber = 0;
            this.total = 0;
            this.finished = false;
            this.loading = true;
            this.loadOrders();
        },
        loadOrders() {
            const nextPage = this.pageNumber + 1;
            const url = this.orderType === 'pro' ? '/bbs/pay/list' : '/bbs/pay/app';
            this.$bbs.get(url, {
                params: {search: {}, sort: {}, total: this.total || 1, pageSize: this.pageSize, pageNumber: nextPage},
                need: {error: true},
            }).then(response => {
                const data = response.data || {};
                const list = Array.isArray(data.data) ? data.data : [];
                this.orders = nextPage === 1 ? list : this.orders.concat(list);
                this.total = Number(data.total) || this.orders.length;
                this.pageNumber = Number(data.pageNumber) || nextPage;
                this.finished = !list.length || this.orders.length >= this.total;
            }).catch(() => {
                this.finished = true;
            }).finally(() => {
                this.loading = false;
            });
        },
        productName(order) {
            if (this.orderType === 'app') return order.product_title || order.product_name || order.product_id || '手机 APP 产品';
            if (order._product_name) return order._product_name;
            const time = `${order.year ? `${order.year}年` : ''}${order.month ? `${order.month}月` : ''}${order.day ? `${order.day}天` : ''}`;
            if (Number(order.auth_type) === 3) return `网络版${time ? ` · ${time}` : ''}`;
            if (Number(order.auth_type) === 2) return `订阅版${time ? ` · ${time}` : ''}`;
            return order.product_title || '产品订单';
        },
        statusInfo(order) {
            const status = Number(this.orderType === 'pro' ? order.pay_status : (order.is_payed != null ? order.is_payed : order.pay_status));
            const map = {
                0: {text: '待付款', type: 'warning'},
                1: {text: '已付款', type: 'success'},
                8: {text: '退款中', type: 'primary'},
                9: {text: '已退款', type: 'default'},
                10: {text: '已关闭', type: 'default'},
            };
            return map[status] || {text: '处理中', type: 'primary'};
        },
        invoiceText(status) {
            return {1: '等待开票', 2: '已开票', 4: '等待开票', 5: '订单关闭'}[Number(status)] || '未填写开票信息';
        },
        formatPrice(value) {
            const amount = Number(value);
            return Number.isFinite(amount) ? amount.toFixed(2) : '0.00';
        },
        formatTime(value) {
            if (!value) return '—';
            if (typeof value === 'string' && !/^\d{10,13}$/.test(value)) return value;
            const number = Number(value);
            const date = new Date(number < 1000000000000 ? number * 1000 : number);
            const pad = item => String(item).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },
    },
};
</script>

<style scoped lang="less">
.mobile-orders-page { min-height: 100vh; color: #1e2737; background: #f5f6f8; }
.mobile-orders-page /deep/ .van-nav-bar--fixed { z-index: 100 !important; background: #fff; box-shadow: 0 1px 8px rgba(24,34,53,.06); }
.mobile-orders-page /deep/ .van-nav-bar__title { font-size: 17px; font-weight: 650; }
.mobile-orders-main { padding: 12px 12px 30px; }
.mobile-orders-hero { display: flex; overflow: hidden; min-height: 130px; padding: 21px 19px; align-items: center; justify-content: space-between; color: #fff; background: radial-gradient(circle at 91% 10%, rgba(245,198,100,.38), transparent 31%), linear-gradient(140deg, #172238, #33445e); border-radius: 18px; box-shadow: 0 10px 27px rgba(31,45,68,.17); }
.mobile-orders-hero span { color: #e4bd6e; font-size: 9px; font-weight: 800; letter-spacing: 1.3px; }
.mobile-orders-hero h1 { margin: 6px 0 7px; font-size: 23px; }
.mobile-orders-hero p { max-width: 250px; margin: 0; color: rgba(255,255,255,.68); font-size: 12px; line-height: 1.5; }
.mobile-orders-hero > .van-icon { color: rgba(255,255,255,.13); font-size: 67px; }
.mobile-orders-main /deep/ .van-tabs { margin-top: 15px; border-radius: 14px 14px 0 0; }
.mobile-orders-main /deep/ .van-tabs__wrap { border-radius: 14px; }
.mobile-orders-toolbar { display: flex; padding: 15px 4px 9px; align-items: center; justify-content: space-between; color: #929baa; font-size: 12px; }
.mobile-orders-toolbar button { padding: 5px 8px; color: #8a6529; background: #f4ead5; border: 0; border-radius: 999px; }
.mobile-orders-list { display: grid; gap: 12px; }
.mobile-order-card { overflow: hidden; padding: 17px 15px 0; background: linear-gradient(155deg,#fff 56%,#fffbf3); border: 1px solid #e5e7ec; border-top: 3px solid #d09b35; border-radius: 16px; box-shadow: 0 7px 22px rgba(32,45,67,.055); }
.mobile-order-card header { display: flex; align-items: center; gap: 10px; }
.mobile-order-card header > div:nth-child(2) { min-width: 0; flex: 1; }
.mobile-order-card header span { color: #a58a5f; font-size: 9px; font-weight: 800; letter-spacing: 1px; }
.mobile-order-card header h2 { overflow: hidden; margin: 3px 0 0; font-size: 17px; text-overflow: ellipsis; white-space: nowrap; }
.mobile-order-card__product-icon { display: flex; width: 39px; height: 39px; flex: 0 0 39px; align-items: center; justify-content: center; color: #8a611c; font-size: 20px; background: linear-gradient(135deg,#fff1c5,#e3b759); border-radius: 12px; }
.mobile-order-card__price { display: flex; margin-top: 15px; padding: 12px; align-items: center; justify-content: space-between; background: #faf7f0; border-radius: 10px; }
.mobile-order-card__price span { color: #9b8b70; font-size: 12px; }
.mobile-order-card__price strong { color: #8b5c13; font-size: 20px; }
.mobile-order-card__details { display: grid; padding: 12px 2px; gap: 9px; }
.mobile-order-card__details div { display: flex; min-width: 0; justify-content: space-between; gap: 15px; }
.mobile-order-card__details span { flex: none; color: #9ba3af; font-size: 11px; }
.mobile-order-card__details strong { overflow: hidden; color: #596477; font-size: 12px; font-weight: 550; text-align: right; text-overflow: ellipsis; white-space: nowrap; }
.mobile-order-card footer { display: flex; margin: 0 -15px; padding: 11px 15px; align-items: center; justify-content: space-between; color: #847051; font-size: 11px; background: rgba(239,222,184,.25); }
.mobile-order-card footer span { display: flex; align-items: center; gap: 5px; }
.mobile-order-card footer strong { font-size: 12px; }
</style>
